import {Link, StarIcon, makeStyles} from '@yandex-delivery/blocks'
import React from 'react'
import {useTheme} from 'src/shared/hooks/useTheme'

import {useStyles} from './styles'

type Props = {
  'data-e2e'?: string
  selected: boolean
  onClick: VoidFunction
}

const useStarStyles = makeStyles({
  root: {
    width: 40,
    height: 40,
  },
})

const Star: React.FC<Props> = ({selected, onClick, 'data-e2e': dataE2e}) => {
  const theme = useTheme()
  const starClasses = useStarStyles()
  const classes = useStyles()
  const unselectedColor = theme === 'dark' ? '#5C5A57' : '#F1F0ED'

  return (
    <Link className={classes.star} onClick={onClick}>
      <StarIcon
        classes={starClasses}
        data-e2e={dataE2e}
        htmlColor={selected ? '#FCE000' : unselectedColor}
        viewBox="0 0 40 40"
      />
    </Link>
  )
}

export default Star
